// Módulo puro, sin imports ni efectos: vive aparte de customErrorProcessors, que registra procesadores al importarse, para que los componentes lo usen sin cargar ese registro.
//
// Resuelve un field name (camelCase) al label del langStore para una entidad
// específica. Prueba primero el nombre tal cual (taxId → AuthorComposerTaxIdLabel)
// y si no existe y termina en "Id" (FK), prueba sin el sufijo
// (nationalityId → AuthorComposerNationalityLabel).
export function resolveEntityFieldLabel(
  langStore: any,
  entityType: string,
  field: string,
): string {
  if (!entityType || !field) return field;
  const ucFirst = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

  const direct = `${entityType}${ucFirst(field)}Label`;
  const directVal = langStore?.[direct];
  if (typeof directVal === "string" && directVal.length > 0) return directVal;

  if (field.endsWith("Id")) {
    const stripped = field.slice(0, -2);
    const strippedKey = `${entityType}${ucFirst(stripped)}Label`;
    const strippedVal = langStore?.[strippedKey];
    if (typeof strippedVal === "string" && strippedVal.length > 0) return strippedVal;
  }
  return field;
}
